/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.35"
        height="95.58"
        viewBox="0 0 95.35 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M46.01 28.8v3.3l-.51.09-.51.11a7.88 7.88 0 0 0-5.95 4.83 9.75 9.75 0 0 0-.69 4.5 7.73 7.73 0 0 0 4.15 6.57 32.41 32.41 0 0 0 3.45 1.55c1.45.61 2.92 1.17 4.37 1.78a2.64 2.64 0 0 1 1.64 2.88 2.85 2.85 0 0 1-2.3 2.88 8.08 8.08 0 0 1-1.83.2 4.54 4.54 0 0 1-4.65-3.39c-.13-.4-.23-.82-.36-1.27l-5.52 1.43a11.54 11.54 0 0 0 2.67 5.46 9.32 9.32 0 0 0 6.05 2.78v4.27h3.57v-4.22c.71-.14 1.41-.25 2.09-.43a8.23 8.23 0 0 0 5.82-4.71 9.59 9.59 0 0 0 .67-5.76 7.6 7.6 0 0 0-3.86-5.48 42.77 42.77 0 0 0-5.29-2.31c-1.08-.43-2.13-.93-3.18-1.44a2.3 2.3 0 0 1-1.18-1.44 3.22 3.22 0 0 1 2.25-4.06 3.76 3.76 0 0 1 3.69 1 7.09 7.09 0 0 1 1.51 2.28c.12.27.23.54.35.83l5-2a10.05 10.05 0 0 0-1.82-3.72 8.71 8.71 0 0 0-6-3.13V28.8Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M29.17 65.16a1.26 1.26 0 0 1 1.25 1.12V80.5a1.25 1.25 0 0 1-2.49.13v-13H14.81a1.24 1.24 0 0 1-1.24-1.13v-.13a1.24 1.24 0 0 1 1.12-1.24h14.48Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M28.23 65.58a1.25 1.25 0 0 1 1.86 1.67l-.09.1L2.13 95.22a1.25 1.25 0 0 1-1.85-1.67l.09-.1ZM29.17 13.56a1.26 1.26 0 0 1 1.25 1.12v14.49a1.26 1.26 0 0 1-1.12 1.25H15.08a1.25 1.25 0 0 1-.13-2.49h13V14.81a1.25 1.25 0 0 1 1.13-1.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M.37.37a1.24 1.24 0 0 1 1.66-.1l.1.1 27.88 27.87a1.25 1.25 0 0 1 0 1.77 1.27 1.27 0 0 1-1.67.09l-.1-.09L.37 2.13a1.24 1.24 0 0 1 0-1.76ZM80.5 65.16a1.25 1.25 0 0 1 .13 2.49h-13.2V80.5a1.26 1.26 0 0 1-1.12 1.25h-.13a1.24 1.24 0 0 1-1.24-1.12V66.41a1.24 1.24 0 0 1 1.12-1.24H80.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M65.3 65.5a1.24 1.24 0 0 1 1.67 0l.1.09L94.98 93.5a1.25 1.25 0 0 1-1.66 1.86l-.1-.09L65.3 67.3a1.24 1.24 0 0 1 0-1.8ZM66.18 13.56a1.25 1.25 0 0 1 1.24 1.12v13.24h12.84a1.24 1.24 0 0 1 1.24 1.12v.13a1.26 1.26 0 0 1-1.12 1.25h-14.2a1.26 1.26 0 0 1-1.25-1.12V14.81a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M93.22.37a1.25 1.25 0 0 1 1.86 1.66l-.1.1-27.9 27.91a1.25 1.25 0 0 1-1.77 0 1.27 1.27 0 0 1-.09-1.67l.09-.1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DollarSignWithFourArrowsPointingInwardIcon';

export default Icon;
